export const DOCUMENT_TYPE_TAILORED_INTERIOR_FRONTPAGE = 'commerce.tailoredInteriorFrontpage';
export const TAILORED_INTERIOR_FRONTPAGE_SLUG = 'skreddersydd-interior';
export const TAILORED_INTERIOR_FRONTPAGE_ID = 'commerceTailoredInteriorFrontpage';
